import styles from './index.module.scss'
import {Link} from 'react-router-dom'
import {Calendar,Map} from '../../../../icons'
import {useLayoutEffect, useState} from 'react'
import Helper from '../../../../utils/Helper'

const VacancyCard = ({img,title,text,date,link,place}) => {
   const [width, setWidth] = useState(false)
    useLayoutEffect(() => {
        function updateSize() {
            if (window.innerWidth <= 768) {
                setWidth(true)
                return
            }
            setWidth(false)
        }

        window.addEventListener('resize', updateSize);
        updateSize();
    }, []);
    console.log(text);
   return (
      <Link to={link} className={`${styles.card} bpg-card-neon`}>
         <div>
            <h2>{Helper.textLengthChecker(title,46)}</h2>
            <p dangerouslySetInnerHTML={{__html : width?Helper.textLengthChecker(text,106):Helper.textLengthChecker(text,208)}} />
            <div className={styles.info}>
               <span><Calendar/> {date}</span>
               <span><Map/> {width?Helper.textLengthChecker(place,14):place}</span>
            </div>
         </div>
         <img src={img} alt={title} />
      </Link>
   )
}

export default VacancyCard